import React, { useState } from 'react';
import SEO from '@/components/foundations/seo';
import OpenAITracking from '@/components/foundations/openaiTracking';

import ModalContent from '@/components/objects/bownow';

// page comp
import KeyVisual from '@/components/pages/uireview/keyVisual';
import Problem from '@/components/pages/uireview/problem';
import Solution from '@/components/pages/uireview/solution';
import SolutionModal from '@/components/pages/uireview/solutionModal';
import Service from '@/components/pages/uireview/service';
import Output from '@/components/pages/uireview/output';
import OutputModal from '@/components/pages/uireview/outputModal';
import SpecialOffer from '@/components/pages/uireview/specialOffer';
import OurClients from '@/components/pages/uireview/ourClients';
import WhoWeAre from '@/components/pages/uireview/whoWeAre';
import Conversion from '@/components/pages/uireview/conversion';
import Modal from '@/components/foundations/modal';

const IndexPage: React.FC<{ routeRef: React.RefObject<HTMLDivElement> }> = ({ routeRef }) => {
  const [active, setActive] = useState(false);
  const [outputModalActive, setOutputModalActive] = useState(false);
  const [outputModalContent, setOutputModalContent] = useState<null | React.FC>(null);
  const [solutionModalActive, setSolutionModalActive] = useState(false);
  const [solutionModalContent, setSolutionModalContent] = useState<null | React.FC>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const modalHandler = (): void => {
    setActive(true);
  };

  const outputModalHandler = (content: React.FC): void => {
    setOutputModalContent(content);
    setOutputModalActive(true);
  };

  const solutionModalHandler = (content: React.FC): void => {
    setSolutionModalContent(content);
    setSolutionModalActive(true);
  };

  return (
    <>
      <SEO
        title='使いやすさを向上させるUI専門家による改善提案サービス'
        description='WEBサービスやシステムの“使いやすさ”を向上させます。ユーザビリティの専門家による、低コスト・短期間の改善策提案「UIエキスパートレビュー」を是非お試しください。'
        ogImage={`https://${process.env.GATSBY_DOMAIN}${process.env.GATSBY_PATH}/assets/img/uireview/ogp.png`}
        pageName='uireview'
      />
      <OpenAITracking />
      <KeyVisual modal={modalHandler} isScrolled={isScrolled} />
      <Problem setScroll={setIsScrolled} />
      <Solution modal={solutionModalHandler} />
      <Service />
      <Output modal={outputModalHandler} />
      <OurClients />
      <WhoWeAre />
      <Conversion modal={modalHandler} />
      <Modal isOpen={active} setter={setActive} routeRef={routeRef} isStatic>
        <ModalContent sid="sid_dc254ec6cf40b3df589b"/>
      </Modal>
      <SolutionModal isOpen={solutionModalActive} setter={setSolutionModalActive} routeRef={routeRef} isStatic>
        {solutionModalContent}
      </SolutionModal>
      <OutputModal isOpen={outputModalActive} setter={setOutputModalActive} routeRef={routeRef} isStatic>
        {outputModalContent}
      </OutputModal>
    </>
  );
};

export default IndexPage;
